"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PingController = void 0;
class PingController {
    constructor(logger) {
        this.logger = logger;
        this.onPingIntermediate = (pingTime) => { };
        this.onPingComplete = (data) => { };
        this.onPingError = (e) => { };
        // default values will be overwritten in ping()
        this.pingMaxNum = 20; // maximum number of pings
        this.pingMaxTime = 5; // maximum overall time in seconds
        this.pingDelay = 0.250; // delay between two pings in seconds
        this.url = "wss://speedtest-22.vodafone.anw.net/ping/";
        this.stopHandler = undefined; // stop handler
        this.pingHandler = undefined; // next ping handler
        this.ws = null;
        this.timeSent = null;
        this.pingStartTime = null; // milliseconds since 01.01.1970
        this.pingStopTime = null; // milliseconds since 01.01.1970
        this.pingDuration = 0; // actual duration of measurement in seconds
        this.completed = false;
        this.pingControllerResult = {
            intermediateValues: [],
            transferDuration: 0
        };
        // send a single ping with index variable
        // -------------------------------------------------------------------------
        this.ping = () => {
            if (this.ws && this.ws.readyState === WebSocket.OPEN) {
                this.debug("sending ping");
                this.timeSent = new Date().getTime();
                this.ws.send("1");
                return true;
            }
            else {
                this.debug("not sending ping");
                return false;
            }
        };
        this.onMessage = () => {
            const self = this;
            this.debug("ping onmessage");
            let timeDiff = (new Date().getTime() - this.timeSent) / 1000;
            this.debug(`#${this.pingControllerResult.intermediateValues.length}: ${timeDiff}`);
            this.pingControllerResult.intermediateValues.push(timeDiff);
            this.onPingIntermediate(timeDiff);
            this.debug("ping values length = " + this.pingControllerResult.intermediateValues.length);
            if (this.pingControllerResult.intermediateValues.length < this.pingMaxNum) {
                // send next ping if maximum number was not reached
                clearTimeout(this.pingHandler);
                this.pingHandler = window.setTimeout(() => self.ping(), this.pingDelay * 1000);
            }
            else {
                this.finish();
            }
        };
        this.onOpen = () => {
            this.debug("ping onOpen");
            this.ping();
        };
        this.onError = (e) => {
            this.debug("ping onError", e);
            this.stop();
            this.onPingError(e);
        };
        // stop the ping test
        // -------------------------------------------------------------------------
        this.stop = () => {
            this.debug("ping stop");
            this.pingStopTime = new Date().getTime();
            if (this.pingStartTime && this.pingStartTime > 0) {
                let duration_ms = this.pingStopTime - this.pingStartTime;
                this.pingControllerResult.transferDuration = duration_ms / 1000;
            }
            // remove handlers
            clearTimeout(this.pingHandler);
            clearTimeout(this.stopHandler);
            // close the connection, if it is open
            if (this.ws && this.ws.readyState === WebSocket.OPEN) {
                this.ws.close();
            }
        };
        this.finish = () => {
            this.stop();
            if (!this.completed) {
                this.completed = true;
                this.onPingComplete(this.pingControllerResult);
            }
        };
        // start the test
        // -------------------------------------------------------------------------
        this.start = () => {
            // need a copy for "this" for the timeout event handlers
            const self = this;
            this.pingStartTime = new Date().getTime();
            this.debug(`ping start, url = ${this.url}`);
            // create WebSocket and open it
            this.ws = new WebSocket(this.url);
            // WebSocket message handler
            this.ws.onmessage = self.onMessage;
            // WebSocket error handler
            this.ws.onerror = self.onError;
            // WebSocket open hanlder
            this.ws.onopen = self.onOpen;
            // set stop timeout handler
            clearTimeout(this.stopHandler);
            this.stopHandler = window.setTimeout(() => {
                self.finish();
            }, this.pingMaxTime * 1000);
        };
        // -------------------------------------------------------------------------
        this.debug = (message, obj) => {
            this.logger.debug(message, obj);
        };
    }
}
exports.PingController = PingController;
//# sourceMappingURL=PingController.js.map